import axios from 'axios';

const url = '/api/ReferenceDataItems';

const CompetencyService = {
  add(payload) {
    return axios.post(url, payload);
  },
  deleteById(id) {
    return axios.delete(`${url}/${id}`);
  },
  getAll() {
    return axios.get(url);
  },
  getById(id) {
    return axios.get(`${url}/${id}`);
  },
  update(payload) {
    return axios.put(url, payload);
  },
};

export default CompetencyService;
